import { ArrowRightOutlined } from '@ant-design/icons';
import { Display } from '@/components/Display/Display';
import s from './style.module.scss';
import { useEffect, useRef, useState } from 'react';
import { cloneDeep } from 'lodash';
import SendFile from './components/SendFile';
import Image from './components/Image';
import React from 'react';
import useSendFile from '@/pages/hooks/useSendFile';
import { inject, observer } from 'mobx-react';
const SenderFiles = (props) => {
    const { chatStore } = props.store;
    const { setAgentFile, agentFile: fileList } = chatStore;
    const listRef = useRef();
    const { needParse = false } = props;
    const [isAtLeft, setIsAtLeft] = useState(true);
    const [isAtRight, setIsAtRight] = useState(false);
    const { command, canClickCommand, handleCommand } = useSendFile();
    const close = (index) => {
        let temData = cloneDeep(fileList);
        temData.splice(index, 1);
        setAgentFile(temData);
    };
    const changeFile = (index, file) => {
        // 关键：传递更新器函数给setAgentFile，入参是Mobx维护的最新fileList状态
        setAgentFile((latestFileList) => {
            // 基于最新状态深克隆，避免修改原始Mobx状态
            const temData = cloneDeep(latestFileList);
            console.log(temData, 'temDatatemData');
            // 对最新的克隆数组执行修改
            temData[index] = file;
            // 返回新的数组作为最新状态
            return temData;
        });
    };
    //处理推荐指令

    // useEffect(() => {
    //     handleCommand(fileList);
    // }, [fileList]);
    const getScrollBoxEdge = () => {
        let scrollBox = listRef.current;
        const { scrollLeft, scrollWidth, clientWidth } = scrollBox;
        const isAtLeft = scrollLeft === 0;
        const isAtRight = scrollLeft >= scrollWidth - clientWidth - 1;
        return {
            isAtLeft,
            isAtRight
        };
    };
    const onScroll = () => {
        let { isAtLeft, isAtRight } = getScrollBoxEdge();
        setIsAtLeft(isAtLeft);
        setIsAtRight(isAtRight);
    };

    return (
        <>
            <div ref={listRef} className={s['files-wrap']} data-from={'sender'} data-left={!isAtLeft} data-right={!isAtRight} onScroll={onScroll}>
                {fileList.map((ele, index) => {
                    return (
                        <React.Fragment key={ele?.uid || index}>
                            <SendFile from={'sender'} needParse={needParse} changeFile={changeFile} close={close} index={index} file={ele}></SendFile>
                            {/* <Display show={ele.type === fileTypeMap.file}>
                                <SendFile from={from} close={close} index={index} needParse={needParse} file={ele}></SendFile>
                            </Display>
                            <Display show={ele.type === fileTypeMap.img}>
                                <Image img={ele} side={side} />
                            </Display> */}
                        </React.Fragment>
                    );
                })}
            </div>
            <Display show={command.length > 0}>
                <div className={s['tip-word-wrap']}>
                    {command.map((ele, index) => {
                        return (
                            <div data-disable={!canClickCommand} key={index} className={s['tip-word']}>
                                <span>{ele}</span>
                                <span>
                                    <ArrowRightOutlined />
                                </span>
                            </div>
                        );
                    })}
                </div>
            </Display>
        </>
    );
};

export default inject('store')(observer(SenderFiles));
